<script setup>
import {ref, inject} from 'vue';
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import sendPostRequest from "@/utils/sendsPostRequests";

const $t = inject("translator");

const showDropdown = ref(false);
const sites = ref([{
  label: 'German',
  locale: 'de',
}, {
  label: 'English',
  locale: 'en',
}]);

const props = defineProps({
  entryId: Number,
  withShadow: {
    type: Boolean,
    default: true,
  }
})

const switchLanguage = async () => {
  localStorage.setItem('user-set-locale', '1');
  const {status, json} = await sendPostRequest('/actions/site-module/localization/switch-locale', {
    entryId: props.entryId,
    currentLocale: window.headlessTranslator.locale,
  })
  window.location.replace(json.redirectTo);
}

const isDisabled = (locale) => {
  return locale === window.headlessTranslator.locale;
}

</script>

<template>

  <Menu as="div" class="inline-block relative">
    <MenuButton
        :class="{'shadow dark:shadow-black transition-shadow': withShadow}"
        class="px-4 py-2 rounded outline-steel shadow-steel-200 hover:shadow-steel-300 dark:hover:shadow-steel-700 border-2 border-steel-100 dark:border-steel flex text-base inline-flex items-center outline-steel-200 dark:outline-steel focus:outline outline-2">
      <span class="font-medium whitespace-nowrap">Choose language</span>
      <svg viewBox="0 0 24 24"
           :class="[showDropdown ? 'rotate-180' : '', 'w-4 h-4 ml-2 text-steel-300 transform transition-transform ease-out']"
           fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502"
              stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>
    </MenuButton>

    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">

      <MenuItems
          class="bg-white dark:bg-steel-800 shadow dark:shadow-black shadow-steel-300 absolute left-0 origin-top-left mt-2 rounded border-2 border-steel-200 dark:border-steel min-w-full divide-y-2 divide-steel-200 overflow-hidden focus:outline-none">
        <MenuItem
            v-slot="{ active }"
            v-for="site in sites"
            :disabled="isDisabled(site.locale)"
        >
          <button @click.prevent="switchLanguage"
                  class="w-full text-left px-4 py-2 hover:bg-steel-100 dark:hover:bg-steel-700 focus:ring-2 focus:ring-pink"
                  :class="{'bg-steel-100': active, 'opacity-50 pointer-events-none': isDisabled(site.locale)}">
            {{ site.label }}
          </button>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>
